import React from "react";
import { Input } from "antd";
import "./TextInput.scss";

export default function TextInput(props) {
  const { title, type, placeholder, values = "true", ...otherProps } = props;
  return (
    <>
      {type === "shadow" ? (
        <Input.Password
          prefix={title}
          className="input-text"
          {...otherProps}
          placeholder={placeholder}
        />
      ) : (
        <Input
          prefix={title}
          {...otherProps}
          className="input-text"
          placeholder={placeholder}
        />
      )}
    </>
  );
}
